const TrainerCore = require("../TrainerCore");

//This is currently an exact copy of standard.js. Once lessons where problems are sequential
//and there shouldn't be extra unlocked are changed to this, standard will move to having
//more problems open at a time.

const settings = {
	showStarProgress: true,
	canReplayProblem: true,
	canSwitchSet: true,
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

const shouldIntervene = function(result) {
	return TrainerCore.genericShouldIntervene(result.problems);
};

module.exports = {
	settings,
	getSetProgressInfo,
	shouldIntervene,
};
